import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { makeURL } from '../../../helperFunctions';
import MarketingStrategyReport from './MarketingStrategyReport';

const ReportExportRoutes = () => (
  <Switch>
    <Route path={makeURL('/report-export/marketing-strategy/:id')} exact component={MarketingStrategyReport} />
    <Redirect to={makeURL('/home')} />
  </Switch>
);

export default ReportExportRoutes;
